import React from "react";
import "./BotonAction.css";

export default function BotonAccion({
  onClick,
  children,
  loading = false,
  disabled = false,
}) {
  return (
    <button
      className="boton-accion"
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? "Cargando..." : children}
    </button>
  );
}
